import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useAuth } from "../context/auth";
import StarRatings from "react-star-ratings";
import ProgressBar from "../components/elements/ProgressBar";
import axios from "axios";
import authHeader from "../services/auth.header";
import { Header2 } from "../components/elements/Header";
import bod from "../assets/svg/bodis.svg";
import skin from "../assets/svg/skin.svg";

const HeaderCont = styled.h1`
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 26px;
  letter-spacing: 0.005em;
  color: #fffcf2;
`;

const BackBtn = styled.button`
  font-family: Poppins !important;
  font-style: normal;
  font-weight: bold;
  font-size: 2vh;
  text-align: center;
  letter-spacing: 0.005em;
  color: #fdfffc;
  background: transparent;
  border: none;
  cursor: pointer;
  margin-left: 20px;
  right: 3.57%;
  margin-top: 20px;
`;

const LabelSvg = styled.img`
  display: block;
  top: 0;
  left: 0;
  overflow: visible;
  width: 39px;
  height: 18px;
`;

const Matchstat = styled.h1`
  font-family: Playfair Display;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  color: #fffcf2;
`;

const Percent = styled.h1`
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 20px;
  letter-spacing: 0.005em;
  color: #fffcf2;
`;

const AttLabel = styled.h1`
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 20px;
  letter-spacing: 0.005em;
  color: #bfbfbf;
`;

const BoldText = styled.h1`
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.005em;
  color: #fdfffc;
`;

const MedScore = styled.h1`
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.005em;
  color: #e5333b;
`;

const HighScore = styled.h1`
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.005em;
  color: #a91e5e;
`;

const Size = styled.h1`
  font-family: Playfair Display;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  color: #fffcf2;
`;

const DescText = styled.h1`
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 20px;
  letter-spacing: 0.005em;
  color: #fdfffc;
`;

const Container = styled.div`
  padding: 16px;
  width: 328px;
  height: 230px;
  background-color: #171111;
  border-radius: 8px;
`;

const RankingContainer = styled.div`
  padding: 16px;
  width: 328px;
  height: auto;
  background-color: #171111;
  border-radius: 8px;
`;

const ColorContainer = styled.div`
  padding: 16px;
  width: 328px;
  height: auto;
  background-color: #171111;
  border-radius: 8px;
  margin-bottom: 40px;
`;

const ColorInd = styled.div`
  width: 16px;
  height: 16px;
  background-color: #ff0000;
  border-radius: 50%;
  margin-right: 8px;
`;

const RecTag = styled.div`
  background: linear-gradient(
    90deg,
    #f89825 0%,
    #f26322 17.75%,
    #e5333b 46.66%,
    #c81d5e 86.72%,
    #a91e5e 97.37%
  );
  width: auto;
  border-radius: 4px;
  margin-left: 16px;
  align-items: center;
  border: none;
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 11px;
  line-height: 26px;
  /* or 186% */
  color: #fdfffc;
  text-align: center;
  letter-spacing: 0.005em;
`;
export default function SuitabilityRating(props) {
  const product = props.location.state.data;
  const [suitabilityItem, setSuitabilityItem] = useState({});
  const { ratingStat, dispatchScore, user } = useAuth();

  useEffect(() => {
    axios
      .post(
        "https://catway.services.ombre.app/v1/products/variants/suitability",
        {
          variantId: product.productVariantId,
          payload: {
            userId: `${user && user.data ? user.data.id : user.id}`,
            gender: "male",
            body_shape: "oval",
            skin_tone: "olive",
            height: "170",
            weight: "74",
          },
        },
        { headers: authHeader() }
      )
      .then((res) => {
        setSuitabilityItem(res.data.data);
        dispatchScore(res.data.data);
      })
      .catch((err) => {
        console.log("error");
      });
  }, []);

  const highScore = () => {
    if (suitabilityItem && suitabilityItem.size) {
      const score = suitabilityItem.size;
      const maxScore = score.reduce((p, c) =>
        p.confidence_score > c.confidence_score ? p : c
      );
      return maxScore;
    }
  };

  const finalScore = highScore();

  const conScore = () => {
    if (suitabilityItem.size && finalScore.confidence_score <= 79) {
      return <MedScore>medium</MedScore>;
    } else if (suitabilityItem.size && finalScore.confidence_score >= 80) {
      return <HighScore>high</HighScore>;
    } else if (suitabilityItem.size && finalScore.confidence_score <= 30) {
      return <p>low</p>;
    }
  };

  return (
    <>
      <div style={{ marginTop: "40px" }}>
        <Header2>Suitability Rating</Header2>
      </div>
      <div
        className="d-flex justify-content-center"
        style={{ marginTop: "40px" }}
      >
        <StarRatings
          rating={suitabilityItem.stars}
          starRatedColor="rgba(244, 177, 103, 1)"
          starEmptyColor="rgba(244, 177, 103, 0.5)"
          isSelectable={false}
          numberOfStars={5}
          name="rating"
          starDimension="24px"
        />
      </div>
      <div
        className="d-flex justify-content-center"
        style={{ marginTop: "16px" }}
      >
        <Matchstat>{suitabilityItem.description}</Matchstat>
      </div>
      <div
        className="d-flex justify-content-center"
        style={{ marginTop: "16px" }}
      >
        <Container>
          <div className="d-flex row">
            <RecTag>Recommended</RecTag>
          </div>
          <div
            className="d-flex justify-content-between"
            style={{ marginTop: "16px" }}
          >
            <div style={{ marginLeft: "16px" }}>
              <AttLabel>Confidence score:</AttLabel>
              {finalScore && <Size>{finalScore.confidence_score}%</Size>}
            </div>
            <div>
              <AttLabel>Size:</AttLabel>
              {finalScore && <Size>{finalScore.prediction}</Size>}
            </div>
          </div>
          <div style={{ marginTop: "15px" }}>
            {finalScore && (
              <ProgressBar
                completed={finalScore.confidence_score}
                backWidth={"292"}
              />
            )}
          </div>
          <div
            className="d-flex justify-content-between"
            style={{ marginTop: "16px" }}
          >
            <div className="d-flex" style={{ marginLeft: "16px" }}>
              {conScore()}
              <BoldText style={{ marginLeft: "10px" }}>
                confidence score
              </BoldText>
            </div>
            <div>
              <AttLabel>What's this?:</AttLabel>
            </div>
          </div>
        </Container>
      </div>
      <div
        className="d-flex justify-content-center"
        style={{ marginTop: "16px" }}
      >
        <RankingContainer>
          <HeaderCont>Style Ranking</HeaderCont>
          <div
            className="d-flex row"
            style={{ marginTop: "24px", marginLeft: "0px" }}
          >
            <LabelSvg src={bod} />
            {suitabilityItem.justification && (
              <ProgressBar
                completed={suitabilityItem.justification.style.bodyShape.score}
                backWidth={"250"}
              />
            )}
            {suitabilityItem.justification && (
              <Percent>
                {suitabilityItem.justification.style.bodyShape.score}%
              </Percent>
            )}
          </div>
          <div
            className="d-flex row"
            style={{ marginTop: "8px", marginLeft: "0px" }}
          >
            {suitabilityItem.justification && (
              <DescText>
                {suitabilityItem.justification.style.description}
              </DescText>
            )}
          </div>
        </RankingContainer>
      </div>
      <div
        className="d-flex justify-content-center"
        style={{ marginTop: "16px" }}
      >
        <ColorContainer>
          <HeaderCont>Color Ranking</HeaderCont>
          <div
            className="d-flex row"
            style={{ marginTop: "24px", marginLeft: "0px" }}
          >
            <LabelSvg src={skin} />
            {suitabilityItem.justification && (
              <ProgressBar
                completed={suitabilityItem.justification.colour.skinTone.score}
                backWidth={"250"}
              />
            )}
            {suitabilityItem.justification && (
              <Percent>
                {suitabilityItem.justification.colour.skinTone.score}%
              </Percent>
            )}
          </div>
          <div
            className="d-flex row"
            style={{ marginTop: "8px", marginLeft: "0px" }}
          >
            {suitabilityItem.justification && (
              <DescText>
                {suitabilityItem.justification.colour.description}
              </DescText>
            )}
          </div>
        </ColorContainer>
      </div>
    </>
  );
}
